import { render } from "./Primary4.vue?vue&type=template&id=3b0a47ea&ts=true"
import script from "./Primary4.vue?vue&type=script&lang=ts"
export * from "./Primary4.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/images/avatars/Primary4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b0a47ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b0a47ea', __exports__)) {
    api.reload('3b0a47ea', __exports__)
  }
  
  module.hot.accept("./Primary4.vue?vue&type=template&id=3b0a47ea&ts=true", () => {
    api.rerender('3b0a47ea', render)
  })

}


export default __exports__